import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as AdditionalUserMdl from '../models/AdditionalUser';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface AdditionalUserProcessing { type: 'ADDITIONALUSER_PROCESSING', processing: boolean }
export interface AdditionalUserError { type: 'ADDITIONALUSER_ERROR', error: string }
export interface AdditionalUserSuccess { type: 'ADDITIONALUSER_SUCCESS' }
export interface AdditionalUserReset { type: 'ADDITIONALUSER_RESET' }


export type KnownAction = AdditionalUserProcessing | AdditionalUserError | AdditionalUserSuccess | AdditionalUserReset;

export const actionCreators = {
    createUser: (pAdditionalUser: AdditionalUserMdl.AdditionalUser): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        pAdditionalUser.customerNumber = sessionState.SelectedAR.id;
        pAdditionalUser.companyCode = sessionState.SelectedAR.companyCode;
        pAdditionalUser.serviceMasterNumber = sessionState.SelectedSM.id;

        dispatch({ type: 'ADDITIONALUSER_PROCESSING', processing: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/AdditionalPhones',
            {
                method: 'POST',
                body: JSON.stringify(pAdditionalUser),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {

                if (container.success) {
                    const data: boolean = container.data;
                    //Do something with response             
                    dispatch({ type: 'ADDITIONALUSER_SUCCESS' });
                } else {
                    dispatch({
                        type: 'ADDITIONALUSER_ERROR', error: container.errorInfo.message
                    });
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: container.errorInfo.clientMessage })
                }
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'ADDITIONALUSER_ERROR', error: err.message
                });
                sawinFunc.log({ message: err.message, logType: LogTypes.Error, clientMessage: '' });
            });
    }    ,
      resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
          dispatch({ type: "ADDITIONALUSER_RESET" });
    }

};

export const reducer: Reducer<AdditionalUserMdl.AdditionalUser> = (state: AdditionalUserMdl.AdditionalUser | undefined, incomingAction: Action): AdditionalUserMdl.AdditionalUser => {

    if (state === undefined) {
        return { ...AdditionalUserMdl.initialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'ADDITIONALUSER_PROCESSING':
            return { ...state, processing: (action as AdditionalUserProcessing).processing }
        case 'ADDITIONALUSER_ERROR':
            return { ...state, processing: false, error: (action as AdditionalUserError).error }
        case 'ADDITIONALUSER_SUCCESS':
            return { ...state, processing: false, error: '', success: 'Y' }
        case 'ADDITIONALUSER_RESET':
           
            return { ...state, ...AdditionalUserMdl.initialState }
        default:
            return state;
    }
};

